import type { FetchOptions } from '../../../types';

export const fetchJsonEnhanced = async (data: FetchOptions) => {
  const res = await fetch(data.url, data);
  const json = await res.json();
  return { ...json, status: res.status };
};
